var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Utils, PropertyConverters, Components, PropertyChangeEvent } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
// TODO: shadow-ize and reuse native <a> element.
let PacemAnchorElement = class PacemAnchorElement extends Components.PacemElement {
    constructor() {
        super('link');
        this._fetching = false;
    }
    ///
    get fetching() {
        return this._fetching;
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.hasAttribute('tab-order')) {
            this.tabOrder = 0;
        }
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'target':
                (Utils.isNullOrEmpty(val) ? Utils.removeClass : Utils.addClass)(this, 'a-target');
                break;
            case 'href':
                (Utils.isNull(val) ? Utils.removeClass : Utils.addClass)(this, 'a-url');
                break;
            case 'download':
                (Utils.isNullOrEmpty(val) ? Utils.removeClass : Utils.addClass)(this, 'a-download');
                break;
        }
    }
    emit(evt) {
        super.emit(evt);
        if (this.disabled) {
            return;
        }
        switch (evt.type) {
            case 'mousedown':
                Utils.addClass(this, PCSS + '-active');
                break;
            case 'keydown':
                if (evt.key === 'Enter') {
                    evt.preventDefault();
                    Utils.addClass(this, PCSS + '-active');
                }
                break;
            case 'blur':
            case 'mouseup':
                Utils.removeClass(this, PCSS + '-active');
                break;
            case 'keyup':
                if (evt.key === 'Enter') {
                    this.click();
                    Utils.removeClass(this, PCSS + '-active');
                }
                break;
        }
        const href = this.href, target = this.target, router = this.router, filename = this.download;
        const url = () => {
            return Utils.isNull(router) ? href : Utils.URIs.format(href, router.state);
        };
        if (!Utils.isNull(href) && !evt.defaultPrevented) {
            if ((evt.type === 'click' && evt.ctrlKey) || (evt.type === 'mousedown' && evt.button === 1)) {
                // 1. middle-click or ctrl+click
                window.open(url(), '_blank');
            }
            else if (evt.type === 'click') {
                // 2. download
                if (filename === true) {
                    this._download(url());
                }
                else if (typeof filename === 'string' && !Utils.isNullOrEmpty(filename)) {
                    this._download(url(), filename);
                }
                // 3. targeting other window
                else if (!Utils.isNullOrEmpty(target)) {
                    window.open(url(), target);
                }
                // 4. routed navigation
                else if (!Utils.isNull(router)) {
                    // old implementation memento: Pacem.preventDefaultHandler(evt);
                    // trigger router `navigate()`
                    router.path = href;
                }
                // 5. standard behavior
                else {
                    location.assign(href);
                }
            }
        }
    }
    async _download(url, filename) {
        this.dispatchEvent(new PropertyChangeEvent({
            propertyName: 'fetching', oldValue: this._fetching, currentValue: this._fetching = true
        }));
        try {
            await Utils.download(url, { credentials: this.fetchCredentials, headers: this.fetchHeaders, filename: filename });
        }
        finally {
            this.dispatchEvent(new PropertyChangeEvent({
                propertyName: 'fetching', oldValue: this._fetching, currentValue: this._fetching = false
            }));
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemAnchorElement.prototype, "fetchCredentials", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemAnchorElement.prototype, "fetchHeaders", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemAnchorElement.prototype, "href", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemAnchorElement.prototype, "target", void 0);
__decorate([
    Watch({
        reflectBack: false, converter: {
            convert: (attr) => {
                switch (attr) {
                    case 'true':
                        return true;
                    case 'false':
                        return false;
                    default:
                        return attr;
                }
            }, convertBack: (prop) => prop
        }
    })
], PacemAnchorElement.prototype, "download", void 0);
__decorate([
    Watch({ reflectBack: false, converter: PropertyConverters.Element })
], PacemAnchorElement.prototype, "router", void 0);
PacemAnchorElement = __decorate([
    CustomElement({
        tagName: P + '-a'
    })
], PacemAnchorElement);
export { PacemAnchorElement };
